import { render } from "./DiplomaStatus.vue?vue&type=template&id=014bf7d8&scoped=true"
import script from "./DiplomaStatus.vue?vue&type=script&lang=js"
export * from "./DiplomaStatus.vue?vue&type=script&lang=js"

import "../css/SubmittedDispositions.css?vue&type=style&index=0&id=014bf7d8&scoped=true&lang=css"
import "./DiplomaStatus.vue?vue&type=style&index=1&id=014bf7d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014bf7d8"]])

export default __exports__